const appInfoList = [
  {
    code: 'yanbian', // 盐边集团 OA
    port: null,
    entryPath: '',
    query: {
      token: true,
      appInfo: false
    }
  },
  {
    code: 'roses-website', // 自主建站后台
    port: '8020', // 开发环境 端口号
    entryPath: '/login', // 登录页 路由
    query: {
      token: true, // 是否需要携带 token 作为参数
      appInfo: true // 是否需要携带 appInfo 作为参数
    }
  },
  {
    code: 'roses-screen', // 盐边大屏管理子系统
    port: '8080',
    entryPath: '/loading',
    query: {
      token: true,
      appInfo: true
    }
  },
  {
    code: 'wj-laboratory', // 温江实验室
    port: '81',
    entryPath: '/user/login',
    query: {
      token: true,
      appInfo: true
    }
  },
  {
    code: 'whole-process', // 全过程管理
    port: '8888',
    entryPath: '/loading',
    query: {
      token: true,
      appInfo: true,
      orgId: true // 是否需要携带 orgId 作为参数
    }
  },
  {
    code: 'qgczxt', // 全过程管理（外部）
    port: null,
    entryPath: '',
    query: {
      account: true,
      pwd: true
    }
  },
  {
    code: 'traffic-construction', // 交投安全管理
    port: '9527',
    entryPath: '/login',
    query: {
      token: true,
      appInfo: true,
      tenantInfo: true,
      appType: true,
      orgId: true // 是否需要携带 orgId 作为参数
    }
  }, {
    code: 'smart-mine', // 自主建站后台
    port: '9000', // 开发环境 端口号
    entryPath: '/login', // 登录页 路由
    query: {
      token: true, // 是否需要携带 token 作为参数
      appInfo: true, // 是否需要携带 appInfo 作为参数
      tenantInfo: true,
      appType: true,
      orgId: true
    }
  },
  {
    code: 'fs', // 自贡晨光园区
    port: '10000', // 开发环境 端口号
    entryPath: '/login', // 登录页 路由
    query: {
      token: true, // 是否需要携带 token 作为参数
      appInfo: false, // 是否需要携带 appInfo 作为参数
      tenantInfo: false,
      appType: false,
      orgId: false
    }
  },
  {
    code: 'default', // 默认设置，必须放在最末尾
    port: '8071',
    entryPath: '/#/login',
    query: {
      token: true,
      appInfo: true
    }
  }
];
export default appInfoList;
